import React, { useEffect, useRef } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link, useNavigate } from "react-router-dom";
import { verifyAuth } from "../services/authservices";
import authService from "../services/authservices";

function TermsCondition() {
  const navigate = useNavigate();
  const [offset, setOffset] = useState(0);
  const advanceSectionRef = useRef(null);
  const [userAuth, setAuth, userAuthref] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (advanceSectionRef.current) {
        const sectionTop = advanceSectionRef.current.offsetTop;
        const sectionHeight = advanceSectionRef.current.offsetHeight;
        const pageOffset = window.pageYOffset;

        if (
          pageOffset >= sectionTop &&
          pageOffset <= sectionTop + sectionHeight
        ) {
          setOffset(pageOffset - sectionTop);
        } else {
          setOffset(0);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    checkuserAuth();
  }, [0]);

    useEffect(() => {
      getSitedata();
    }, []);
    const [siteDatacomes, setSiteData] = useState("");


      const getSitedata = async () => {
        try {
          const data = await authService.getsitedata();
          if (data.status == true) {
            setSiteData(data.data);
            console.log(data, "=-=-=get site datas =-=-", data.data);
          }
        } catch (error) {}
      };
    
  const checkuserAuth = async () => {
    const token = localStorage.getItem("token");
    if (token != null) {
      try {
        const data = await verifyAuth(token);
        if (data && data.status) {
          setAuth(true);
        } else {
          setAuth(false);
        }
      } catch (error) {
        console.error("Error auth user details:", error);
        setAuth(false);
      }
    } else {
      setAuth(false);
    }
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const nav_page = () => {
    if (!userAuthref.current) {
      navigate("/register");
    } else {
      navigate("/home");
    }
  };

  return (
    <>
      <main className="wyscale_landing_main">
        <section>
          <Header />
        </section>
        <section className="dashboard_content_section">
          <div className="container">
            <div className="smart_dashboard_content" id="terms-condition">
              <h2>Term’s and conditions</h2>
              <div className="row">
                <div className="col-lg-12">
                  <div className="dash_board_profile_content">
                    <div className="contentpage">
                      <h3>Service Introduction </h3>
                      <h4>NOTICE:</h4>

                      <p>
                      Please read this Agreement carefully as it governs your use of the Interface. This Agreement contains important information, including a binding arbitration provision and a class action waiver, both of which impact your rights as to how disputes are resolved.
                      The Interface is a software tool for automated trading execution and is not an investment service. Binarge does not provide financial advice, manage assets, or offer investment products. All trades executed through the software are initiated by the user and remain under the user’s control.
                      </p>

                      <h5>Modification of this Agreement: </h5>
                      <p>
                      We reserve the right, in our sole discretion, to modify this Agreement from time to time. If we make any modifications, we will notify you by updating the date at the top of the Agreement and by maintaining a current version of the Agreement at [ ]. All modifications will be effective when they are posted, and your continued use of the Interface will serve as confirmation of your acceptance of those modifications. If you do not agree with any modifications to this Agreement, you must immediately stop accessing and using the Interface.
                      </p>

                      <h5>Eligibility: </h5>
                      <p>
                      To access or use the Interface, you must be able to form a legally binding contract with us. Accordingly, you represent that you are at least the age of majority in your jurisdiction (e.g., eighteen years old) and have the full right, power, and authority to enter into and comply with the terms and conditions of this Agreement.{" "}
                      </p>

                      <p>
                        You further represent that:
                      </p>
                      <p>
                      You are not the subject of economic or trade sanctions administered or enforced by any governmental authority or otherwise designated on any list of prohibited or restricted parties. You will fully comply with all applicable laws and regulations.You will not access or use the Interface to conduct, promote, or facilitate any illegal activity.
                      </p>

                      <h4 className="mt-4"> Key Disclaimers and Assumption of Risk </h4>

                      <p>
                      By accessing and using the Interface, you acknowledge and accept the following:

Binarge provides automated trading software only. We do not provide financial or investment advice, nor do we manage funds on behalf of users.
All trades executed using the software are fully controlled by the user. Users bear full responsibility for the trading strategies they implement and their associated risks.
The cryptocurrency market is highly volatile. Users may experience gains or losses when executing trades using the software. Binarge is not responsible for any trading outcomes.
The cost and speed of blockchain transactions can fluctuate due to network congestion, gas fees, and other factors. Users must account for these potential costs when using the software.
We do not own or control any underlying blockchain protocol or exchange. We are not responsible for any system failures, hacks, or losses resulting from third-party services or blockchain networks.
By using the Interface, you agree that Binarge is not liable for any losses, including but not limited to, trading losses, lost opportunities, or operational disruptions.

                      </p>

                      <h4>Additional Rights </h4>
                      <p>
                      We reserve the following rights, which do not constitute obligations of ours:
                      </p>

                      <p>
                      To modify, substitute, eliminate, or add to the Interface at our sole discretion.
To review, filter, disable, delete, or remove any and all content from the Interface.
To cooperate with any law enforcement, court, government investigation, or order as required by law.

                      </p>

                      <h4>Entire Agreement </h4>
                      <p>
                      This Agreement constitutes the entire agreement between you and us regarding the subject matter herein. It supersedes any prior or contemporaneous written or oral agreements, communications, and understandings related to your use of the Interface.
                      </p>
                      <p>
                      If you have any questions about these Terms, please contact us at wecare(@)binarge.com
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="footer_section">
          <div className="container">
            <section className="row mx-0 bn-footer-row g-4 g-lg-1">
              <div className="col-lg-6 col-sm-6 col-12">
                <div>
                  <img
                    src={require("./img/footer-logo.webp")}
                    alt=""
                    className="bn-footer-logo"
                  />
                  <p className="bn-footer-logo-content">
                    AI-powered crypto trading bot with blockchain security for
                    seamless and automated trading.
                  </p>
                </div>
              </div>
              <div className="col-lg-2 col-sm-4 col-6">
                <h6 className="bn-footer-link-title">Explore</h6>
                <ul className="bn-footer-lists">
                  {/* <li>
                    <Link to="/" className="bn-footer-links">
                      Newbies
                    </Link>
                  </li>
                  <li>
                    <Link to="/" className="bn-footer-links">
                      Knowledge Base
                    </Link>
                  </li>
                  <li>
                    <Link to="/" className="bn-footer-links">
                      Strategies
                    </Link>
                  </li> */}
                 <li>
                    <Link to="/termscondition" className="bn-footer-links">
                      Terms and Service
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacypolicy" className="bn-footer-links">
                      Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-lg-2 col-sm-6 col-6">
                <h6 className="bn-footer-link-title">Support</h6>
                <ul className="bn-footer-lists">
                  {/* <li>
                              <Link to="/" className="bn-footer-links">
                                Terms & Conditions
                              </Link>
                            </li>
                            <li>
                              <Link to="/" className="bn-footer-links">
                                Privacy Policy
                              </Link>
                            </li> */}
                  <li>
                    <Link to={userAuthref.current ? "/support" : "/login"} className="bn-footer-links">
                      Help Center
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-2 col-sm-6 col-6">
                <h6 className="bn-footer-link-title">Social</h6>
                <ul className="bn-footer-icon-wrap">
                <li>
                        <a target="_blank" href={siteDatacomes.instagram}>
                            <img src={require("./img/instagram.webp")} alt="" />
                          </a>
                        </li>
                        <li>
                        <a target="_blank"  href={siteDatacomes.twitter}>
                            <img src={require("./img/x.webp")} alt="" />
                          </a>
                        </li>
                        <li>
                        <a target="_blank" href={siteDatacomes.telegram}>
                        <img src={require("./img/telegram.webp")} alt="" />
                          </a>
                        </li>
                </ul>
              </div>
            </section>
          </div>
        </section>
        <div className="footer_last">
          <span className="footer_copyrights">
            ©2025 Binarge. All Rights Reserved.
          </span>
        </div>
      </main>
    </>
  );
}

export default TermsCondition;
